export const defaultServiceRequestTemplate = (baseDate: Date = new Date()) => `{
  "serviceName": "Domestic Delivery Request",
  "serviceDescription": "Road transport for consumer goods distribution",
  "serviceType": "TRANSPORT",
  "serviceSubtype": "ROAD_TRANSPORT",
  "serviceNature": "LOGISTICS",
  "requestDateTime": "${baseDate.toISOString()}",
  "requestStatus": "REQUESTED",
  "isDangerous": false,
  "requestor": {
    "commercialName": "ACME SARL"
  },
  "provider": {
    "commercialName": "My Provider Company"
  },
  "startLocation": {
    "location": {
      "address": {
        "addressLocality": "Lyon",
        "postalCode": "69000",
        "addressCountry": {
          "countryCode": "FR",
          "countryName": "France"
        }
      }
    },
    "requestedStartTimeRange": {
      "earliestDateTime": "${baseDate.toISOString()}",
      "latestDateTime": "${new Date(baseDate.getTime() + 2 * 60 * 60 * 1000).toISOString()}"
    }
  },
  "endLocation": {
    "location": {
      "address": {
        "addressLocality": "Paris",
        "postalCode": "75015",
        "addressCountry": {
          "countryCode": "FR",
          "countryName": "France"
        }
      }
    },
    "requestedEndTimeRange": {
      "earliestDateTime": "${new Date(baseDate.getTime() + 24 * 60 * 60 * 1000).toISOString()}",
      "latestDateTime": "${new Date(baseDate.getTime() + 30 * 60 * 60 * 1000).toISOString()}"
    }
  },
  "consignments": [
    {
      "uri": "urn:bol:consignment:cons-001"
    }
  ],
  "requestedActivities": [
    {
      "uri": "urn:bol:activity:act-001"
    }
  ],
  "externalReferences": [
    {
      "externalReferenceType": "CUSTOMER_ID",
      "reference": "SR-2026-001"
    }
  ]
}`;
